export type GraphicsQualityId = 'low' | 'balanced' | 'high';

export interface GraphicsQualityOption {
  id: GraphicsQualityId;
  name: string;
  description: string;
  icon: string;
  dpr: [number, number];
  shadowResolution: number;
  environmentResolution: number;
  anisotropy: number;
  particleRatio: number;
}

export const graphicsQualityOptions: readonly GraphicsQualityOption[] = [
  {
    id: 'low', name: '성능', description: '낮은 해상도 · 입자 45%', icon: '▱',
    dpr: [0.8, 1], shadowResolution: 256, environmentResolution: 128, anisotropy: 2, particleRatio: 0.45,
  },
  {
    id: 'balanced', name: '균형', description: '권장 품질과 성능', icon: '◩',
    dpr: [1, 1.5], shadowResolution: 384, environmentResolution: 256, anisotropy: 4, particleRatio: 0.72,
  },
  {
    id: 'high', name: '고품질', description: '고해상도 · 전체 효과', icon: '▰',
    dpr: [1, 2], shadowResolution: 512, environmentResolution: 384, anisotropy: 8, particleRatio: 1,
  },
];

export const DEFAULT_GRAPHICS_QUALITY_ID: GraphicsQualityId = 'balanced';

export function findGraphicsQualityById(id: string): GraphicsQualityOption | undefined {
  return graphicsQualityOptions.find((option) => option.id === id);
}
